import { ApprovalPoliciesService } from "@common/client"
import { makeAxiosMutation, makeNoArgsQuery, makeQuery } from "./utils"

export const approvalPoliciesBaseKey = ["approval-policies"] as const

export const approvalPoliciesKey = (tenantId: string) =>
  [...approvalPoliciesBaseKey, tenantId] as const

export const approvalPoliciesQuery = makeQuery({
  serviceCall: ApprovalPoliciesService.getApprovalPolicies,
  queryKey: (params) => approvalPoliciesKey(params.tenant_id),
})

export const workspaceApprovalPoliciesKey = [
  "workspace-approval-policies",
] as const

export const workspaceApprovalPoliciesQuery = makeNoArgsQuery({
  serviceCall: ApprovalPoliciesService.listApprovalPolicies,
  queryKey: workspaceApprovalPoliciesKey,
})

export const approvalPolicyReferenceKey = (tenantId: string) =>
  ["approval-policy-reference", tenantId] as const

export const approvalPolicyReferenceQuery = makeQuery({
  serviceCall: ApprovalPoliciesService.getApprovalPolicyReference,
  queryKey: (params) => approvalPolicyReferenceKey(params.tenant_id),
})

export const useUpdateApprovalPoliciesMutation = makeAxiosMutation({
  serviceCall: ApprovalPoliciesService.updateApprovalPolicies,
  invalidates: (params) => [
    approvalPoliciesKey(params.tenant_id),
    workspaceApprovalPoliciesKey,
  ],
})

export const approvalPolicyOptionsKey = ["approval-policy-options"] as const

export const approvalPolicyOptionsQuery = makeNoArgsQuery({
  serviceCall: ApprovalPoliciesService.getApprovalPolicyOptions,
  queryKey: approvalPolicyOptionsKey,
})

const changedPolicyKeys = () => [
  workspaceApprovalPoliciesKey,
  approvalPoliciesBaseKey,
]

export const useCreateApprovalPolicyMutation = makeAxiosMutation({
  serviceCall: ApprovalPoliciesService.createApprovalPolicy,
  invalidates: changedPolicyKeys,
})

export const useEditApprovalPolicyMutation = makeAxiosMutation({
  serviceCall: ApprovalPoliciesService.editApprovalPolicy,
  invalidates: changedPolicyKeys,
})

export const useDeleteApprovalPolicyMutation = makeAxiosMutation({
  serviceCall: ApprovalPoliciesService.deleteApprovalPolicy,
  invalidates: changedPolicyKeys,
})

export const useOrderApprovalPoliciesMutation = makeAxiosMutation({
  serviceCall: ApprovalPoliciesService.orderApprovalPolicies,
  invalidates: changedPolicyKeys,
})
